import React, { useEffect } from "react";

const fiturData = [
  { title: "A. General Akses", items: ["Akses per user", "Audit log aktivitas user"] },
  { title: "B. Master Data", items: ["Gudang, Lokasi (Bin), Produk, Customer, Vendor", "Kategori Produk", "Satuan (UoM)"] },
  { title: "C. Inbound / Receiving", items: ["Input PO No", "Putaway otomatis", "Cetak Form Putaway"] },
  { title: "D. Outbound / Shipping", items: ["Input Order, auto picking list", "Validasi FIFO"] },
  { title: "E. Inventory Management", items: ["Real-time stok", "Movement log"] },
  { title: "F. Laporan & Export", items: ["Laporan stok, inbound/outbound", "Export Excel"] },
];

const alurData = [
  { title: "INBOUND", description: "Inbound Order • Approval • Putaway", imgSrc: "https://stardiatech.com/wp-content/uploads/2025/08/inbound.png", alt: "Inbound" },
  { title: "INVENTORY", description: "Realtime Stock • Movement Log", imgSrc: "https://stardiatech.com/wp-content/uploads/2025/08/stock.png", alt: "Inventory" },
  { title: "OUTBOUND", description: "Outbound Order • Picking (FIFO)", imgSrc: "https://stardiatech.com/wp-content/uploads/2025/08/outbound.png", alt: "Outbound" },
];

const Web = () => {
  useEffect(() => {
    // Update tahun secara otomatis
    const yearEl = document.getElementById("y");
    if (yearEl) yearEl.textContent = new Date().getFullYear();

    // Smooth scroll
    const anchors = document.querySelectorAll('a[href^="#"]');
    const handleClick = (e) => {
      const id = e.currentTarget.getAttribute("href").slice(1);
      const el = document.getElementById(id);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    anchors.forEach((a) => a.addEventListener("click", handleClick));
    return () => anchors.forEach((a) => a.removeEventListener("click", handleClick));
  }, []);

  return (
    <div className="font-sans text-gray-800 bg-gray-50">
      {/* HEADER */}
      <header className="bg-white shadow">
        <div className="container mx-auto flex justify-between items-center px-14 py-4">
          <a href="https://stardiatech.com" className="flex items-center">
            <img
              src="https://stardiatech.com/wp-content/uploads/2023/03/cropped-logo-stardia-web.png"
              alt="STARDIA technology"
              className="h-10"
            />
          </a>
          <nav className="flex gap-6">
            <a href="#fitur" className="text-gray-700 hover:text-orange-500 text-lg">Fitur</a>
            <a href="#alur" className="text-gray-700 hover:text-orange-500 text-lg">Alur Proses</a>
            <a href="#hubungi" className="text-gray-700 hover:text-orange-500 text-lg">Hubungi</a>
            <a href="https://wms.stardiatech.com/login" className="text-orange-600 font-semibold hover:underline text-lg">Login</a>
          </nav>
        </div>
      </header>

      {/* HERO */}
      <section className="bg-white shadow">
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between px-14 py-16">
          <div className="max-w-lg">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">Stardia WMS</h1>
            <p className="text-lg mb-6">
              Solusi <strong>Warehouse Management System (WMS)</strong> siap pakai
              untuk memperlancar aktivitas di gudang anda (inbound–inventory–outbound),
              dengan arsitektur modern dan mudah digunakan.
            </p>
            <a
              href="#fitur"
              className="inline-block border border-orange-500 text-orange-500 px-5 py-2 rounded-lg hover:bg-orange-500 hover:text-white transition"
            >
              Lihat Fitur
            </a>
          </div>
          <img
            src="https://stardiatech.com/wp-content/uploads/2025/08/ilus-warehouse.png"
            alt="Ilustrasi WMS MVP"
            className="w-64 h-64 mt-8 md:mt-0"
          />
        </div>
      </section>

      {/* OVERVIEW */}
      <section className="py-16 bg-orange-50">
        <div className="container mx-auto grid md:grid-cols-2 gap-8 px-14">
          <div className="bg-white p-6 rounded-xl shadow">
            <h2 className="text-xl font-semibold mb-4">Masalah Di Gudang !!</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Tim gudang kesulitan mengetahui Stock Barang.</li>
              <li>Tim gudang tidak tahu order apa saja yang perlu diproses.</li>
              <li>Tim gudang tidak tahu kapan barang akan habis, sehingga sering barang kosong yang membuat gagal supply Pembelian.</li>
            </ul>
          </div>
          <div className="bg-white p-6 rounded-xl shadow">
            <h2 className="text-xl font-semibold mb-4">Pengelolaan Yang Baik</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Operasional terukur dari inbound order, inventory, hingga outbound order.</li>
              <li>Kontrol akses per user.</li>
              <li>Laporan dan audit trail mudah dan cepat didapat.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* FITUR */}
      <section id="fitur" className="bg-gray-100 py-16">
        <div className="container mx-auto px-14">
          <h2 className="text-2xl font-bold mb-8 text-center">Fitur Lengkap</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {fiturData.map((card, idx) => (
              <div key={idx} className="bg-white p-6 rounded-xl shadow">
                <h3 className="font-semibold mb-3">{card.title}</h3>
                <ul className="list-disc pl-6 space-y-2">
                  {card.items.map((item, i) => (<li key={i}>{item}</li>))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ALUR PROSES */}
      <section id="alur" className="bg-white py-16">
		  <div className="container mx-auto px-6 md:px-14">
			<h2 className="text-3xl md:text-2xl font-bold mb-6 md:mb-8 text-center">
			  Alur Proses Utama
			</h2>
			<p className="text-base md:text-lg mb-10 text-center text-gray-600">
			  Alur ringkas dari penerimaan barang hingga pengiriman.
			</p>

			<div className="flex flex-col md:flex-row gap-6 md:gap-8 justify-between">
			  {alurData.map((item, idx) => (
				<div
				  key={idx}
				  className="flex-1 border border-gray-300 rounded-lg p-6 flex flex-col items-center text-center"
				>
				  <img
					src={item.imgSrc}
					alt={item.alt}
					className="h-20 md:h-24 mb-4"
				  />
				  <h3 className="font-bold text-lg md:text-xl mb-2">{item.title}</h3>
				  <p className="text-gray-600 md:text-sm">{item.description}</p>
				</div>
			  ))}
			</div>
		  </div>
		</section>


      {/* CTA */}
      <section id="hubungi" className="bg-orange-500 text-white py-16">
        <div className="container mx-auto px-14 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="max-w-lg">
            <div className="uppercase text-xl tracking-wide font-bold">Sudah Capek Gudang Berantakan ??</div>
            <h2 className="text-xl font-bold my-2">Kontak Kami untuk Request Demo atau Penawaran.</h2>
            <p className="text-orange-100">Tim kami siap membantu untuk Konsultasi, Training, hingga Implementasi.</p>
          </div>
          <a
            className="bg-white text-orange-600 font-semibold px-6 py-3 rounded-lg hover:bg-orange-100 transition flex items-center"
            href="mailto:contactus@stardiatech.com?subject=Request Demo Stardia WMS&body=Halo STARDIA,%0A%0ASaya ingin meminta demo untuk Stardia WMS.%0A%0ATerima kasih."
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="mr-2">
              <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
            </svg>
            Kontak Kami
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-100 text-gray-600 text-center py-4">
        ©<span id="y"></span> - Stardia WMS
      </footer>
    </div>
  );
};

export default Web;
